// extracted by mini-css-extract-plugin
module.exports = {"ldsFacebook":"styles_ldsFacebook__2I9Lq","lightLoader":"styles_lightLoader__3PGw3"};